import { Controller } from "@hotwired/stimulus"

// NOTE: intentionally kept but currently unused — the sync-direction chooser in
// accounts/partials/_integrations was removed while the Google Calendar
// integration is push-only. Left registered so it works again when that chooser
// is restored (mirrors the kept update_sync_direction action + sync service).
//
// Disables the submit button (showing "Up to date") until the selected
// sync direction differs from the one currently saved, then enables it
// (showing "Update sync direction").
export default class extends Controller {
  static targets = ["radio", "submit"]

  connect() {
    this.initial = this.checkedValue
    this.update()
  }

  change() {
    this.update()
  }

  update() {
    const changed = this.checkedValue !== this.initial
    this.submitTarget.disabled = !changed
    this.submitTarget.value = changed ? "Update sync direction" : "Up to date"
  }

  get checkedValue() {
    const checked = this.radioTargets.find((radio) => radio.checked)
    return checked ? checked.value : null
  }
}
